import { httpClient } from "@/service/http_client";
export class EquipmentHistoryServices {
  async fetchHistory(url: string): Promise<any> {
    const response = await httpClient.get(url);
    return response;
  }
}
